// extracted by mini-css-extract-plugin
module.exports = {"container":"AddTimeDialog_container__1I5Jo","minutes":"AddTimeDialog_minutes__AEsY0"};